import { Flex, useHasMounted } from '@stars-ecom/shared-atoms-ui'
import React, { memo } from 'react'

import ByConcernPushThumbnail from './ByConcernPushThumbnail'

const ByConcernPush = (props) => {
  const { push } = props

  const hasMounted = useHasMounted()
  if (!hasMounted) {
    return <div style={{ display: 'none' }} />
  }

  return (
    <Flex 
      direction="column"
      align="center"
      minHeight={{ md: '330px' }} 
      backgroundImage={push?.backgroundImage?.image || null}
      backgroundColor={push?.backgroundColor || '#fff'}>
      <Flex
        direction="row"
        style={{ fontFamily: 'PT Sans', marginTop: '20px' }}
        fontSize={{ base: '25px', md: '30px' }}
        dangerouslySetInnerHTML={{ __html: push?.title }}></Flex>
        <Flex
          gridGap="20px"
          justify={{ base: 'flex-start', md: 'center' }}
          alignContent="flex-start"
          p="20px"
          overflowY="clip" 
          overflowX={{ base: 'scroll', md: 'hidden' }}
          width="100%"
          >
          {push?.byConcernPushes?.map((byConcernPush, i) => (
            <ByConcernPushThumbnail
              key={`by_concern_push_${i}`}
              byConcernPush={byConcernPush}
              classname={`by_concern_push_${i}`}
            />
          ))}
        </Flex>
      </Flex>
  )
}

export default memo(ByConcernPush)
